import BlStructuredListMv from './BlStructuredListMv.vue'

BlStructuredListMv.install = function(Vue) {
  Vue.component(BlStructuredListMv.name, BlStructuredListMv)
}

export default BlStructuredListMv
